import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SubscriptionPricingContent from '../../features/Subscription/SubscriptionPricingContent';
import MainLayout from '../../layouts/MainLayout/MainLayout';
import './Subscription.css'
import { Stack } from '@mantine/core';
import { Helmet } from "react-helmet";
import SubscriptionPreviewContent from '../../features/Subscription/SubscriptionLastContent/SubscriptionPreviewContent';
import SubscriptionFAQ from '../../features/Subscription/SubscriptionFAQ/SubscriptionFAQ';
import { useAppContext } from '../../context/AppState/AppContext';
import showNotification from '../../utils/showNotification';
import { calculatePrice } from '../../utils/calculatePrice';

export default function Subscription() {
   const [subscriptions, setSubscriptions] = useState(null);
   const [isLoadingSubscriptions, setIsLoadingSubscriptions] = useState(false);
   const navigate = useNavigate();
   const { setPaymentData, isUSD, officialUSDValue } = useAppContext();

   useEffect(() => {
      const getSubscriptions = async () => {
         try {
            setIsLoadingSubscriptions(true);
            const { data } = await axios.get(`${process.env.REACT_APP_BACKEND_SERVER}/info/subscriptions`);
            setSubscriptions(data);
         } catch (error) {
            console.log(error);
            showNotification({
               color: "red",
               status: "error",
               title: "Error",
               message: `Error al cargar los planes de suscripción: ${error}`,
            });
         } finally {
            setIsLoadingSubscriptions(false);
         }
      };
      getSubscriptions();
   }, []);

   const handleInscription = (content) => {
      const price = calculatePrice(content?.price, officialUSDValue, isUSD);
      setPaymentData({
         name: content?.name,
         id: content._id,
         price,
         isSubscription: true,
         division: content.division || null,
         subscriptionPlans: content.subscriptionPlans,
      });
      navigate(`/pago`);
   };

   const featuredPlan = subscriptions?.find((s) => s.is_featured) || null;

   return (
      <>
         <Helmet>
            <title>FORVET | Comunidad</title>
            <meta name="description"
               content="Formá parte de una comunidad que apuesta al crecimiento constante, la actualización profesional y el intercambio con colegas apasionados como vos. Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá." />
            <meta property="og:title" content="FORVET | Comunidad" />
            <meta property="og:description"
               content="Formá parte de una comunidad que apuesta al crecimiento constante, la actualización profesional y el intercambio con colegas apasionados como vos. Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá." />
         </Helmet>
         <MainLayout>
            <div className="SubscriptionPage-main-container">
               <h1 className="landingHero__title">
                  Comunidad <br />
                  <span className="landingHero__gradient">
                     Forvet
                  </span>
               </h1>
               <Stack mb={20}>
                  <p className='SubscriptionPage--description'>
                     Formá parte de una comunidad que apuesta al <strong>crecimiento constante</strong>, la <strong>actualización profesional</strong> y el intercambio con colegas apasionados <strong>como vos</strong>.
                  </p>
                  <p className='SubscriptionPage--description'>
                     Descubrí nuevas herramientas, perspectivas y oportunidades diseñadas para llevar tu vocación un paso más allá.
                  </p>
               </Stack>

               <SubscriptionPreviewContent
                  featuredPlan={featuredPlan}
                  isLoadingPlans={isLoadingSubscriptions}
                  onInscription={handleInscription}
               />

               <SubscriptionPricingContent
                  subscriptions={subscriptions}
                  isLoading={isLoadingSubscriptions}
                  onInscription={handleInscription}
               />

               <SubscriptionFAQ />

            </div>
         </MainLayout>
      </>
   )
}